import { render, staticRenderFns } from "./SuperAdmins.vue?vue&type=template&id=65988239&scoped=true"
import script from "./SuperAdmins.vue?vue&type=script&lang=js"
export * from "./SuperAdmins.vue?vue&type=script&lang=js"
import style0 from "./SuperAdmins.vue?vue&type=style&index=0&id=65988239&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65988239",
  null
  
)

export default component.exports